import React, { useState, useRef, useEffect } from 'react';
import { Button, Tooltip } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import domainModel from 'domain-model';
import IconCart from 'flaivy-react/components/icons/IconCart';
import CartOffCanvas from 'flaivy-react/components/cart/CartOffCanvas';
import keyedDebounceSingleton from 'flaivy-react/utils/keyed-debounce-singleton';

const { isPrivabShop } = domainModel.shopConfig;

const CartBadge = ({ persistedMultiCart, bootstrapBreakpoint, shopConfig }) => {
  const { cartUpdateMessage } = persistedMultiCart;
  const [isShowingTooltip, setIsShowingTooltip] = useState(false);

  const firstRender = useRef(true);
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    if (cartUpdateMessage) {
      setIsShowingTooltip(true);
      keyedDebounceSingleton.debounce({
        queue: `shopNavbar${bootstrapBreakpoint}`,
        key: 'delayedClosing',
        delayedFunction: () => {
          setIsShowingTooltip(false);
        },
        delay: 3141,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartUpdateMessage]);
  const totalNumberOfArticles = _.map(persistedMultiCart.carts, cart =>
    cart.cartRows.map(x => x.pricedArticle.id),
  ).flat().length;
  return (
    <div className="pe-1 pe-md-0">
      <IconCart stroke={isPrivabShop(shopConfig) ? 'white' : 'black'} />
      <div className="navbar-icon-badge cart-badge bg-dark text-light">
        <strong>{totalNumberOfArticles}</strong>
      </div>

      <Tooltip
        className={`
              shopping-cart-tooltip ${
                bootstrapBreakpoint === 'lg'
                  ? 'd-none d-lg-flex'
                  : 'd-flex d-lg-none'
              }`}
        key={`cartTooltip${bootstrapBreakpoint}`}
        placement="bottom"
        isOpen={isShowingTooltip}
        target={`ShoppingCartButton${bootstrapBreakpoint}`}
      >
        <div>{cartUpdateMessage}</div>
      </Tooltip>
    </div>
  );
};

CartBadge.propTypes = {
  persistedMultiCart: PropTypes.object.isRequired,
  shopConfig: PropTypes.object.isRequired,
  bootstrapBreakpoint: PropTypes.string,
};

const ShoppingCartButton = ({
  sessionUser,
  bootstrapBreakpoint,
  persistedMultiCart,
  shopConfig,
}) => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const toggleModal = () => {
    setIsCartOpen(!isCartOpen);
  };

  return (
    <>
      {!_.isEmpty(sessionUser) && (
        <>
          <Button
            onClick={toggleModal}
            color="none"
            style={{ width: '30px', height: '30px' }}
            id={`ShoppingCartButton${bootstrapBreakpoint}`}
            className="p-0 me-2 list-inline-item position-relative ms-2"
          >
            <CartBadge
              bootstrapBreakpoint={bootstrapBreakpoint}
              shopConfig={shopConfig}
              persistedMultiCart={persistedMultiCart}
            />
          </Button>
          <CartOffCanvas isOpen={isCartOpen} toggle={toggleModal} />
        </>
      )}
    </>
  );
};

ShoppingCartButton.propTypes = {
  sessionUser: PropTypes.object,
  shopConfig: PropTypes.object.isRequired,
  persistedMultiCart: PropTypes.object.isRequired,
  bootstrapBreakpoint: PropTypes.string,
};

ShoppingCartButton.defaultProps = {
  sessionUser: null,
};

const mapStateToProps = ({
  persistedMultiCart,
  authentication,
  shopConfig,
}) => ({
  persistedMultiCart,
  sessionUser: authentication.sessionUser,
  shopConfig,
});

export default connect(mapStateToProps)(ShoppingCartButton);
